import { useCallback, useEffect, useState } from 'react';
import useOrgChartAnalytics from './useOrgChartAnalytics';
import _get from 'lodash/get';
import useRouter from 'useRouterCompat';
import useWrap from 'helpers/useWrap';

function useFullscreen() {
  const { match } = useRouter({ path: '/:page' });
  const page = _get(match, ['params', 'page'], '') as string;
  const [isFullscreen, setIsFullscreen] = useState(false);
  const getIsFullscreen = useWrap(isFullscreen);
  const fullScreenAnalyticsEvent = useOrgChartAnalytics('Fullscreen Clicked');

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!isFullscreen);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [isFullscreen]);

  const toggleFullscreen = useCallback(() => {
    fullScreenAnalyticsEvent();

    if (!isFullscreen) {
      document.body.requestFullscreen();
      return;
    }

    document.exitFullscreen();
  }, [fullScreenAnalyticsEvent, isFullscreen]);

  useEffect(() => {
    const isFullscreen = getIsFullscreen();

    if (isFullscreen) {
      document.exitFullscreen();
    }
  }, [page, getIsFullscreen]);

  return {
    toggleFullscreen,
    isFullscreen,
  };
}

export default useFullscreen;
